import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { Theme } from '@mui/material';
import { Todo } from '../../../types/types';
import { useTodos } from '../../../context/TodoContext/TodoContext';
import { GetPriorityColor, getStatusColor } from '../../../constants/colors';
import { useNavigate, useParams } from 'react-router-dom';

export const useCalendar = () => {
    const { todos } = useTodos();
    const [currentDate, setCurrentDate] = useState<Dayjs>(dayjs());
    const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
    const { id: selectedTodoId, workspaceId } = useParams();
    const navigate = useNavigate();

    const handlePrevMonth = () => setCurrentDate(currentDate.subtract(1, 'month'));
    const handleNextMonth = () => setCurrentDate(currentDate.add(1, 'month'));

    const getTodosForDate = (date: Dayjs) => {
        return todos.filter(todo => {
            if (!todo.dueDate) return false;
            const dueDate = dayjs(todo.dueDate);
            return dueDate.isSame(date, 'day');
        });
    };

    const getTodosColor = (todos: Todo[], theme: Theme) => {
        if (todos.length === 0) return undefined;

        if (todos.some(todo => todo.completed))
            return getStatusColor(theme).completed;

        if (todos.some(todo => !todo.completed && dayjs().isAfter(dayjs(todo.dueDate))))
            return getStatusColor(theme).overdue;

        if (todos.some(todo => !todo.completed && todo.priority === 'high'))
            return GetPriorityColor(theme).high;

        if (todos.some(todo => !todo.completed && todo.priority === 'medium'))
            return GetPriorityColor(theme).medium;

        if (todos.some(todo => !todo.completed && todo.priority === 'low'))
            return GetPriorityColor(theme).low;

        return undefined;
    };


    const getTodoColor = (todo: Todo, theme: Theme) => {
        if (todo.completed)
            return getStatusColor(theme).completed;

        if (!todo.completed && dayjs().isAfter(dayjs(todo.dueDate)))
            return getStatusColor(theme).overdue;

        if (todo.priority === 'high')
            return GetPriorityColor(theme).high;

        if (todo.priority === 'medium')
            return GetPriorityColor(theme).medium;

        if (todo.priority === 'low')
            return GetPriorityColor(theme).low;
        return undefined;
    };

    const handleDateClick = (date: Dayjs) => {
        setSelectedDate(date);
    };

    const handleTodoClick = (todo: Todo) => {
        navigate(`/calendar/${workspaceId}/${todo.id}`);
    };

    const handleCloseDetail = () => navigate(`/calendar`);

    const generateCalendarDays = () => {
        const startOfMonth = currentDate.startOf('month');
        const startOfCalendar = startOfMonth.startOf('week');
        const days: Dayjs[] = [];

        for (let i = 0; i < 42; i++) {
            days.push(startOfCalendar.add(i, 'day'));
        }

        return days;
    };

    return {
        currentDate,
        selectedDate,
        selectedTodoId,
        handlePrevMonth,
        handleNextMonth,
        getTodosForDate,
        getTodosColor,
        getTodoColor,
        handleDateClick,
        handleTodoClick,
        handleCloseDetail,
        generateCalendarDays,
    };
}; 